module.exports = __webpack_public_path__ + "img/logo_color.f26103c8.svg";